module.exports = __webpack_public_path__ + "static/media/game_background.89100b61.png";